module.exports = __webpack_public_path__ + "media/images/restaurant/loc-63d0d106cc980b7443a4679e9d1b5024.png";